import { Navigate, Route, Routes } from 'react-router-dom';
import ExportPage from './export/ExportPage';
import KeyPage from './key/KeyPage';
import LabelsPage from './labels/LabelsPage';
import PulseKeysPage from './list/PulseKeysPage';
import MoveCustomerKeysPage from './move/MoveCustomerKeysPage';

export default function PulseKeysRouter() {
  return (
    <Routes>
      <Route element={<PulseKeysPage />} index />
      <Route element={<LabelsPage />} path="labels" />
      <Route element={<ExportPage />} path="export" />
      <Route element={<MoveCustomerKeysPage />} path="move-customer-keys" />
      <Route element={<KeyPage />} path=":key" />
      <Route element={<Navigate to="" />} path="*" />
    </Routes>
  );
}
